import moment from 'moment';

type step = 10 | 15 | 30 | 60;

export function generate24Hours(stepMin: step) {
  const minInDay = 60 * 24;
  const baseDate = moment({ hour: 0, minutes: 0 });

  return Array.from(
    { length: minInDay / stepMin },
    (_, i) => {
      return i ?
        baseDate.add(stepMin, 'minutes').format('HH:mm') :
        baseDate.format('HH:mm');
    }
  );
}

export function generateWeekdays() {
  return moment.weekdays();
}
